import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewClientPage.module.css";
import DropDown from "../StatusDropDown/DropDown";
import MessageItem from "./Components/Notes/MessageItem";
import MoreDropDown from "./MoreDropDown";
import Sidebar from "./Components/Sidebar/Sidebar";
import Orders from "./Components/Orders/Orders";
import Notes from "./Components/Notes/Notes";
import Documents from "./Components/Documents/Documents";
import Subscriptions from './Components/Subscriptions/Subscriptions';
import Invoices from "./Components/Invoices/Invoices";
import Forms from "./Components/Forms/Forms";
import Details from "./Components/Details/Details";
import { AnimatePresence } from "framer-motion";
import DeleteConfirmPopup from "../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup";
import AssignFlowPopup from "./AssignFlowPopup/AssignFlowPopup";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function ViewClientPage() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("details");
    const [status, setStatus] = useState("Active");

    const [openAssignFlowPopup, setopenAssignFlowPopup] = useState(false);
    const handleopenAssignFlowPopup = () => {
        setopenAssignFlowPopup(true);
    }

    const handleCloseAssignClientsPopup = () => {
        setopenAssignFlowPopup(false);
    }

    const [openConfirmPopup, setopenConfirmPopup] = useState(false);
    const handleCloseConfirmPopup = () => {
        setopenConfirmPopup(false);
    }
    const handleOpenConfirmPopup = () => {
        setopenConfirmPopup(true);
    }
    const handleConfirmSubmit = () => {
        handleCloseConfirmPopup();
    }

    return (
        <>
            <div className={Classes.container}>
                <div className={Classes.header}>
                    <button onClick={() => navigateTo("/clients")} className={Classes.backButton}>
                        <LeftArrow height='12px' fill='#969696' />
                        <h5>Clients</h5>
                    </button>
                    <MoreDropDown handleopenAssignFlowPopup={handleopenAssignFlowPopup}
                        handleOpenConfirmPopup={handleOpenConfirmPopup} />
                </div>

                <div className={Classes.hero} >
                    <div className={Classes.heroLeft}>
                        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                    </div>
                    <div className={Classes.heroRight} >
                        <div className="flexAlign10 mb-20" style={{ padding: '0 25px' }} >
                            <h3>John Smith</h3>
                            <DropDown selectedValue={status} options={["Active", "Disabled"]} onChange={setStatus} />
                        </div>

                        {activeTab === "details" && <Details />}
                        {activeTab === "notes" && <Notes />}
                        {activeTab === "orders" && <Orders />}
                        {activeTab === "documents" && <Documents />}
                        {activeTab === "subscriptions" && <Subscriptions />}
                        {activeTab === "invoices" && <Invoices />}
                        {activeTab === "forms" && <Forms />}

                    </div>
                </div>

            </div>

            <AnimatePresence>
                {openAssignFlowPopup && <AssignFlowPopup handleClose={handleCloseAssignClientsPopup} />}
            </AnimatePresence>

            <AnimatePresence>
                {openConfirmPopup && <DeleteConfirmPopup handleClose={handleCloseConfirmPopup} handleSubmit={handleConfirmSubmit} />}
            </AnimatePresence>
        </>
    );
}